<template>
  <v-card class="mx-auto overflow-visible " width="500px" style="margin-top: 0px; margin-bottom: 0px;z-index: 99" outlined :loading="isLoadData">
    <v-list-item three-line>
      <v-list-item-content class="overflow-visible d-block">
        <v-row class="align-center">
          <v-col cols="10">
            <v-list-item-title class="headline mb-2">Tìm kiếm nâng cao</v-list-item-title>
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon aria-label="Close" @click="closeMenuPopup">mdi-close</v-icon>
          </v-col>
        </v-row>
        <v-divider style="margin-bottom: 20px;"></v-divider>
        <v-row>
          <v-col>
            <v-row v-if="currentTab === TUTOR_TAB_INDEX.SpecialCare">
              <div style="overflow: auto; max-height: 600px" id="style-2">
                <v-col cols="12">
                  <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Thông tin chăm sóc</div>
                  <v-row>
                    <v-col cols="5" class="d-flex align-center pl-6">
                      Quản lý lớp
                    </v-col>
                    <v-col cols="7">
                      <v-autocomplete
                        @change="toggleSelectTeacher"
                        v-model="filterForm.headTeacher"
                        :placeholder="filterForm.hasNoTeacher ? 'Không có quản lý lớp' : 'Chọn quản lý lớp'"
                        multiple
                        no-data-text="Không có dữ liệu"
                        :items="listGVCNV2"
                        item-text="name"
                        item-value="id"
                        clearable
                        outlined
                        hide-details
                        dense
                        chips
                        small-chips
                        clear-icon="mdi-trash-can-outline"
                      >
                        <template #selection="{item}">
                          <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.headTeacher, item.id)">{{handleCutChipText(item.name, 17)}}</v-chip>
                        </template>
                        <template v-slot:prepend-item>
                          <v-list-item
                            ripple
                            @mousedown.prevent
                            @click="toggleHasNoTeacher"
                          >
                            <v-list-item-action>
                              <v-icon :color="filterForm.headTeacher && filterForm.headTeacher.length > 0 ? 'indigo darken-4' : ''">
                                {{ filterForm.hasNoTeacher ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}}
                              </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>
                                Không có quản lý lớp
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row v-if="$route.query.tutorSchoolLevel === SCHOOL_LEVEL.PRIMARY">
                    <v-col cols="5" class="d-flex align-center pl-6">
                      Số ngày chưa chăm sóc
                    </v-col>
                    <v-col cols="7">
                      <v-row>
                        <v-col cols="12">
                          <div class="d-flex">
                            <v-text-field
                              v-model="rangeNumberLastCare.from"
                              style="margin-top: 2px; padding-top: 0"
                              type="number"
                              min="0"
                              class="custom-input-number"
                              :class="required ? 'required' : ''"
                              @change="changeNumberLastCare('from')"
                              @keydown="$event.key === '-' || $event.key === 'e' || $event.key === '.' ? $event.preventDefault() : null"
                              outlined
                              dense
                              hide-details
                            >
                              <template v-slot:prepend-inner>
                                <div class="mt-1 content-number"  :style="{color: required ? '#FF6B69' : ''}">Từ</div>
                              </template>
                              <template v-slot:append>
                                <div class="mt-1 content-number">Ngày</div>
                              </template>
                            </v-text-field>
                            <v-text-field
                              v-model="rangeNumberLastCare.to"
                              style="margin-top: 2px; padding-top: 0"
                              type="number"
                              class="custom-input-number ml-2"
                              :min="rangeNumberLastCare.from"
                              :class="required ? 'required' : ''"
                              @change="changeNumberLastCare('to')"
                              @keydown="$event.key === '-' || $event.key === 'e' || $event.key === '.' ? $event.preventDefault() : null"
                              outlined
                              dense
                              hide-details
                            >
                              <template v-slot:prepend-inner>
                                <div class="mt-1 content-number"  :style="{color: required ? '#FF6B69' : ''}">Đến</div>
                              </template>
                              <template v-slot:append>
                                <div class="mt-1 content-number">Ngày</div>
                              </template>
                            </v-text-field>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Thông tin lọc học sinh đặc biệt</div>
                  <v-row>
                    <v-col cols="5" class="d-flex align-center pl-6">
                      <v-checkbox
                        label="Nghỉ không phép"
                        v-model="specialCareFilter.studentOff"
                        hide-details
                        class="mt-0"
                        color="green"
                        on-icon="mdi-checkbox-outline"
                        @change="(val) => {
                          if(!val) {
                            filterForm.student_off = ''
                            filterForm.typeStudentOff = ''
                          }
                        }"
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col cols="7">
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        type="number"
                        class="custom-compare-input"
                        :disabled="!specialCareFilter.studentOff"
                        v-model="filterForm.student_off"
                        @keydown="$event.key === '-' || $event.key === 'e' || $event.key === '.' ? $event.preventDefault() : null"
                        min="0"
                      >
                        <template v-slot:append>
                          buổi
                        </template>
                        <template v-slot:prepend-inner>
                          <v-select
                            hide-details
                            style="width: 130px; padding: 0"
                            dense
                            placeholder="So sánh"
                            class="custom-solo-select mt-0"
                            solo
                            item-value="value"
                            item-text="label"
                            v-model="filterForm.typeStudentOff"
                            :items="commonCompareOptions"
                            clearable
                          >
                          </v-select>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="5" class="d-flex align-center pl-6">
                      <v-checkbox
                        label="Đi muộn về sớm"
                        hide-details
                        class="mt-0"
                        color="green"
                        on-icon="mdi-checkbox-outline"
                        v-model="specialCareFilter.studentLateEarly"
                        @change="(val) => {
                          if(!val) {
                            filterForm.studentLateEarly = ''
                            filterForm.typeStudentLateEarly = ''
                          }
                        }"
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col cols="7">
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        class="custom-compare-input"
                        v-model="filterForm.studentLateEarly"
                        :disabled="!specialCareFilter.studentLateEarly"
                        type="number"
                        @keydown="$event.key === '-' || $event.key === 'e' || $event.key === '.' ? $event.preventDefault() : null"
                        min="0"
                      >
                        <template v-slot:append>
                          buổi
                        </template>
                        <template v-slot:prepend-inner>
                          <v-select
                            hide-details
                            style="width: 130px; padding: 0"
                            dense
                            placeholder="So sánh"
                            class="custom-solo-select mt-0"
                            solo
                            item-value="value"
                            item-text="label"
                            :items="commonCompareOptions"
                            v-model="filterForm.typeStudentLateEarly"
                            clearable
                          >
                          </v-select>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="5" class="d-flex align-center pl-6">
                      <v-checkbox
                        label="Không làm bài tập"
                        hide-details
                        class="mt-0"
                        color="green"
                        on-icon="mdi-checkbox-outline"
                        v-model="specialCareFilter.studentHw"
                        @change="(val) => {
                          if(!val) {
                            filterForm.studentHw = ''
                            filterForm.typeStudentHw = ''
                          }
                        }"
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col cols="7">
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        class="custom-compare-input"
                        :disabled="!specialCareFilter.studentHw"
                        v-model="filterForm.studentHw"
                        type="number"
                        @keydown="$event.key === '-' || $event.key === 'e' || $event.key === '.' ? $event.preventDefault() : null"
                        min="0"
                      >
                        <template v-slot:append>
                          bài
                        </template>
                        <template v-slot:prepend-inner>
                          <v-select
                            hide-details
                            style="width: 130px; padding: 0"
                            dense
                            placeholder="So sánh"
                            class="custom-solo-select mt-0"
                            solo
                            item-value="value"
                            item-text="label"
                            :items="commonCompareOptions"
                            v-model="filterForm.typeStudentHw"
                            clearable
                          >
                          </v-select>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="d-flex align-center pl-6">
                      <v-checkbox
                        label="Điểm kiểm tra thấp"
                        hide-details
                        class="mt-0"
                        color="green"
                        on-icon="mdi-checkbox-outline"
                        v-model="filterForm.studentTestLow"
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="5" class="d-flex align-center pl-6">
                      <v-checkbox
                        label="Hủy buổi học"
                        hide-details
                        class="mt-0"
                        color="green"
                        on-icon="mdi-checkbox-outline"
                        v-model="specialCareFilter.studentCancelLesson"
                        @change="(val) => {
                          if(!val) {
                            filterForm.studentCancelLesson = ''
                            filterForm.typeStudentCancelLesson = ''
                          }
                        }"
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col cols="7">
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        class="custom-compare-input"
                        :disabled="!specialCareFilter.studentCancelLesson"
                        v-model="filterForm.studentCancelLesson"
                        type="number"
                        @keydown="$event.key === '-' || $event.key === 'e' || $event.key === '.' ? $event.preventDefault() : null"
                        min="0"
                      >
                        <template v-slot:append>
                          buổi
                        </template>
                        <template v-slot:prepend-inner>
                          <v-select
                            hide-details
                            style="width: 130px; padding: 0"
                            dense
                            placeholder="So sánh"
                            class="custom-solo-select mt-0"
                            solo
                            item-value="value"
                            item-text="label"
                            :items="commonCompareOptions"
                            v-model="filterForm.typeStudentCancelLesson"
                            clearable
                          >
                          </v-select>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="$route.query.tutorSchoolLevel === SCHOOL_LEVEL.PRIMARY">
                    <v-col cols="5" class="d-flex align-center pl-6">
                      <v-checkbox
                        label="Đổi giáo viên cover"
                        hide-details
                        class="mt-0"
                        light
                        color="green"
                        on-icon="mdi-checkbox-outline"
                        v-model="specialCareFilter.studentChangeTeacherCover"
                        @change="(val) => {
                          if(!val) {
                            filterForm.studentChangeTeacherCover = ''
                            filterForm.typeStudentChangeTeacherCover = ''
                          }
                        }"
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col cols="7">
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        class="custom-compare-input"
                        :disabled="!specialCareFilter.studentChangeTeacherCover"
                        v-model="filterForm.studentChangeTeacherCover"
                        type="number"
                        @keydown="$event.key === '-' || $event.key === 'e' || $event.key === '.' ?  $event.preventDefault() : null"
                        min="0"
                      >
                        <template v-slot:append>
                          buổi
                        </template>
                        <template v-slot:prepend-inner>
                          <v-select
                            hide-details
                            style="width: 130px; padding: 0"
                            dense
                            placeholder="So sánh"
                            class="custom-solo-select mt-0"
                            solo
                            item-value="value"
                            item-text="label"
                            :items="commonCompareOptions"
                            v-model="filterForm.typeStudentChangeTeacherCover"
                            clearable
                          >
                          </v-select>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="5" class="d-flex align-center pl-6">
                      <v-checkbox
                        :label="$route.query.tutorSchoolLevel === SCHOOL_LEVEL.PRIMARY ? 'Đổi giáo viên chính' : 'Đổi giáo viên'"
                        hide-details
                        class="mt-0"
                        light
                        color="green"
                        on-icon="mdi-checkbox-outline"
                        v-model="specialCareFilter.studentChangeTeacher"
                        @change="(val) => {
                          if(!val) {
                            filterForm.studentChangeTeacher = ''
                            filterForm.typeStudentChangeTeacher = ''
                          }
                        }"
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col cols="7">
                      <v-text-field
                        outlined
                        dense
                        hide-details
                        class="custom-compare-input"
                        :disabled="!specialCareFilter.studentChangeTeacher"
                        v-model="filterForm.studentChangeTeacher"
                        type="number"
                        @keydown="$event.key === '-' || $event.key === 'e' || $event.key === '.' ?  $event.preventDefault() : null"
                        min="0"
                      >
                        <template v-slot:append>
                          {{$route.query.tutorSchoolLevel === SCHOOL_LEVEL.PRIMARY ? 'lần' : 'buổi'}}
                        </template>
                        <template v-slot:prepend-inner>
                          <v-select
                            hide-details
                            style="width: 130px; padding: 0"
                            dense
                            placeholder="So sánh"
                            class="custom-solo-select mt-0"
                            solo
                            item-value="value"
                            item-text="label"
                            :items="commonCompareOptions"
                            v-model="filterForm.typeStudentChangeTeacher"
                            clearable
                          >
                          </v-select>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                 <v-col cols="12" v-if="$route.query.tutorSchoolLevel === SCHOOL_LEVEL.PRIMARY">
                  <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Thông tin học sinh</div>
                  <v-row>
                    <v-col cols="5" class="d-flex align-center pl-6">
                      Chương trình
                    </v-col>
                    <v-col cols="7">
                      <v-menu
                        bottom
                        offset-y
                        content-class="menu-wrapper-tree-user"
                        :close-on-content-click="false">
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-if="(filterForm.programFilter && filterForm.programFilter.length === 0 && programFilterType === 1) || (filterForm.program_ids && filterForm.program_ids.length === 0 && programFilterType === 2)"
                            v-bind="attrs"
                            v-on="on">
                            <v-select
                              label="Chương trình"
                              readonly
                              hide-details
                              placeholder="Tìm kiếm theo chương trình"
                              outlined
                              dense
                            >
                            </v-select>
                          </div>
                          <div
                            v-bind="attrs"
                            v-on="on"
                            v-else
                            style="position: relative"
                          >
                            <div class="mt-1 tree-user-selected" v-show="programFilterType === 1">
                              <span
                                v-for="(node, index) in computedLevelName"
                                :key="node + index"
                              >
                                <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItemProgram(node, programFilterType, index)">
                                  {{ handleCutChipText(node, 20) }}
                                </v-chip>
                              </span>
                            </div>
                            <div class="mt-1 tree-user-selected" v-show="programFilterType === 2">
                              <span
                                v-for="(node, index) in computedProgramName"
                                :key="node + index"
                              >
                                <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItemProgram(node, programFilterType, index)">
                                  {{ handleCutChipText(node, 20) }}
                                </v-chip>
                              </span>
                            </div>
                            <v-icon
                              class="icon-clear-all"
                              color="grey"
                              @click="removeProgramLevelSelected()">mdi-trash-can-outline
                            </v-icon>
                          </div>
                        </template>
                        <template>
                          <div style="background: white; max-height: 400px; overflow: auto; padding: 0 12px">
                            <div style="min-width: 340px;">
                              <v-radio-group
                                style="justify-content: center"
                                class="custom-radio-group"
                                v-model="programFilterType"
                                row
                                hide-details
                              >
                                <v-radio
                                  label="Chọn theo level"
                                  :value="1"
                                ></v-radio>
                                <v-radio
                                  label="Chọn theo chương trình"
                                  :value="2"
                                ></v-radio>
                              </v-radio-group>
                            </div>
                            <v-text-field
                              class="px-6 pt-4"
                              label="Tìm kiếm..."
                              v-model="search"
                              hide-details
                            >
                            </v-text-field>
                            <v-treeview
                              v-show="programFilterType === 1"
                              v-model="filterForm.programFilter"
                              :search="search"
                              selectable
                              item-key="fakeId"
                              item-disabled="locked"
                              return-object
                              :items="treeListProgram"
                            ></v-treeview>
                            <v-treeview
                              v-show="programFilterType === 2"
                              v-model="filterForm.program_ids"
                              selectable
                              :items="listProgram"
                              :search="search"
                              item-text="title"
                              item-key="id"
                            ></v-treeview>
                          </div>
                        </template>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="5" class="d-flex align-center pl-6">
                      Trạng thái học
                    </v-col>
                    <v-col cols="7">
                      <v-autocomplete
                        v-model="filterForm.status"
                        :items="HS_STATUSESBYQUERY ? HS_STATUSESBYQUERY : []"
                        item-text="name"
                        item-value="id"
                        multiple
                        clearable
                        placeholder="Chọn trạng thái học"
                        hide-details
                        persistent-placeholder
                        dense
                        outlined
                        chips
                        clear-icon="mdi-trash-can-outline"
                      >
                        <template #selection="{ item }">
                          <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.status, item.id)">{{item.name}}</v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Thời gian</div>
                  <v-row v-if="$route.query.tutorSchoolLevel === SCHOOL_LEVEL.PRIMARY">
                    <v-col cols="5" class="d-flex align-center pl-6">
                      Ngày hết hạn
                    </v-col>
                    <v-col cols="7">
                      <common-range-picker
                        :clearable="true"
                        :aLight="'left'"
                        v-model="filterForm.courseEndDate"
                        class="'show-date"
                        :class="this.currentPicker === 1 ? 'show-date' : 'hide-date'"
                        @show-date-picker="showDate(1)"
                        @check-close-on-click="checkCloseOnClick"
                        @input="updateCourseEndDate()"
                        isFilter
                        noneMargin
                      ></common-range-picker>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="5" class="d-flex align-center pl-6" style="line-height: 1.5">
                      Ngày vào danh sách đặc biệt
                    </v-col>
                    <v-col cols="7">
                      <common-range-picker
                        :clearable="true"
                        :aLight="'left'"
                        v-model="filterForm.special_care_timein"
                        class="'show-date"
                        :class="this.currentPicker === 1 ? 'show-date' : 'hide-date'"
                        @show-date-picker="showDate(1)"
                        @check-close-on-click="checkCloseOnClick"
                        isFilter
                        noneMargin
                      ></common-range-picker>
                    </v-col>
                  </v-row>
                  <v-row v-if="$route.query.tutorSchoolLevel === SCHOOL_LEVEL.PRIMARY">
                    <v-col cols="5" class="d-flex align-center pl-6" style="line-height: 1.5">
                      Ngày kiểm tra sắp tới
                    </v-col>
                    <v-col cols="7">
                      <common-range-picker
                        :clearable="true"
                        :aLight="'left'"
                        v-model="filterForm.nextTestDate"
                        class="'show-date"
                        :class="this.currentPicker === 1 ? 'show-date' : 'hide-date'"
                        @show-date-picker="showDate(1)"
                        @check-close-on-click="checkCloseOnClick"
                        isFilter
                        noneMargin
                      ></common-range-picker>
                    </v-col>
                  </v-row>
                  <v-row v-if="$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY">
                    <v-col cols="5" class="d-flex align-center pl-6">
                      Hạn chăm sóc bắt buộc
                    </v-col>
                    <v-col cols="7">
                      <common-range-picker
                        :clearable="true"
                        :aLight="'left'"
                        v-model="filterForm.compulsoryCareDate"
                        class="'show-date"
                        :class="this.currentPicker === 1 ? 'show-date' : 'hide-date'"
                        @show-date-picker="showDate(1)"
                        @check-close-on-click="checkCloseOnClick"
                        isFilter
                        noneMargin
                      ></common-range-picker>
                    </v-col>
                  </v-row>
                  <v-row v-if="$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY">
                    <v-checkbox
                      v-model="filterForm.isOutDateCare"
                      label="Quá hạn chăm sóc đặc biệt"
                      class="pl-6"
                      on-icon="mdi-checkbox-outline"
                    >
                    </v-checkbox>
                  </v-row>
                </v-col>
              </div>
            </v-row>
            <v-row v-else-if="currentTab === TUTOR_TAB_INDEX.TutorTask">
              <v-col cols="12">
                <v-row>
                  <v-col cols="4" class="d-flex align-center">
                    Người thực hiện
                  </v-col>
                  <v-col cols="8">
                    <v-autocomplete
                      @change="toggleSelectTeacher()"
                      v-model="filterForm.userId"
                      :items="listTotalGVCNV2"
                      item-text="name"
                      item-value="id"
                      no-data-text="Không có dữ liệu"
                      placeholder='Chọn người thực hiện'
                      outlined
                      dense
                      clearable
                      multiple
                      hide-details
                      persistent-placeholder
                      chips
                      clear-icon="mdi-trash-can-outline"
                    >
                      <template #selection="{item}">
                        <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.userId, item.id)">
                          {{handleCutChipText(item.name)}}
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="d-flex align-center">
                    Lịch hẹn
                  </v-col>
                  <v-col cols="8">
                    <common-range-picker
                      :clearable="true"
                      :aLight="'left'"
                      v-model="filterForm.appointmentSchedule"
                      class="'show-date"
                      :class="this.currentPicker === 1 ? 'show-date' : 'hide-date'"
                      @show-date-picker="showDate(1)"
                      @check-close-on-click="checkCloseOnClick"
                      noneMargin
                      isFilter
                    ></common-range-picker>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="d-flex align-center">
                    Loại công việc
                  </v-col>
                  <v-col cols="8">
                    <v-autocomplete
                      v-model="filterForm.type"
                      clearable
                      multiple
                      :items="LIST_TYPE_SELECT"
                      item-value="id"
                      item-text="text"
                      placeholder="Chọn loại công việc"
                      no-data-text="Không có dữ liệu"
                      dense
                      outlined
                      hide-details
                      chips
                      clear-icon="mdi-trash-can-outline"
                    >
                      <template #selection="{item}">
                        <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.type, item.id)">
                          {{item.text}}
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row v-if="$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY" >
                  <v-col cols="4" class="d-flex align-center">
                    Khóa học
                  </v-col>
                  <v-col cols="8">
                    <v-autocomplete
                      v-model="filterForm.courseId"
                      :items="listCourse"
                      item-text="name"
                      item-value="id"
                      no-data-text="Không có dữ liệu"
                      placeholder="Chọn khoá học"
                      clearable
                      multiple
                      hide-details
                      persistent-placeholder
                      outlined
                      dense
                      chips
                      clear-icon="mdi-trash-can-outline"
                    >
                      <template #selection="{item}">
                        <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.courseId, item.id)">
                          {{handleCutChipText(item.name)}}
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="d-flex align-center">
                    Trạng thái công việc
                  </v-col>
                  <v-col cols="8">
                    <v-autocomplete
                      v-model="filterForm.status"
                      clearable
                      multiple
                      :items="TASK_STATUS_OPTION"
                      item-value="id"
                      item-text="text"
                      placeholder="Chọn trạng thái công việc"
                      no-data-text="Không có dữ liệu"
                      persistent-placeholder
                      outlined
                      hide-details
                      dense
                      chips
                      clear-icon="mdi-trash-can-outline"
                    >
                      <template #selection="{item}">
                        <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.status, item.id)">
                          {{item.text}}
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="d-flex align-center">
                    Chương trình
                  </v-col>
                  <v-col cols="8">
                    <v-autocomplete
                      v-model="filterForm.curriculumId"
                      :items="listProgram"
                      item-text="title"
                      item-value="id"
                      no-data-text="Không có dữ liệu"
                      placeholder="Chọn chương trình"
                      clearable
                      multiple
                      hide-details
                      dense
                      outlined
                      chips
                      clear-icon="mdi-trash-can-outline"
                    >
                      <template #selection="{item}">
                        <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.curriculumId, item.id)">
                          {{handleCutChipText(item.title)}}
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-else>
              <div style="max-height: 580px; overflow: auto; width: 100%" id="style-2">
                <v-col cols="12">
                  <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Thông tin chăm sóc</div>
                  <v-row v-if="currentTab !== TUTOR_TAB_INDEX.ALL && filterForm.typeCustomerCare === TYPE_CALL_STATUS.CHAM_SOC_DINH_KY">
                    <v-col cols="4" class="d-flex align-center pl-6">
                      Lịch sử cuộc gọi
                    </v-col>
                    <v-col cols="8">
                      <v-autocomplete
                        v-model="filterForm.historyCallId"
                        :items="listCallType ? listCallType : []"
                        item-text="name"
                        item-value="id"
                        placeholder="Chọn lịch sử cuộc gọi"
                        clearable
                        hide-details
                        persistent-placeholder
                        no-data-text="Không có dữ liệu"
                        @change="filterForm.historyCallStatusId = []"
                        dense
                        outlined
                        chips
                        clear-icon="mdi-trash-can-outline"
                      >
                        <template #selection="{ item }">
                          <v-chip color="#F8E5FF">{{item.name}}</v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row v-if="currentTab !== TUTOR_TAB_INDEX.ALL && filterForm.typeCustomerCare !== TYPE_CALL_STATUS.CHAM_SOC_DINH_KY">
                    <v-col cols="4" class="d-flex align-center pl-6">
                      Trạng thái cuộc gọi
                    </v-col>
                    <v-col cols="8">
                      <v-autocomplete
                        v-model="filterForm.callStatuses"
                        :items="countStatusModuleList"
                        item-text="name"
                        item-value="id"
                        placeholder="Chọn lịch sử trạng thái"
                        no-data-text="Không có dữ liệu"
                        clearable
                        multiple
                        hide-details
                        persistent-placeholder
                        dense
                        outlined
                        chips
                        clear-icon="mdi-trash-can-outline"
                      >
                        <template #selection="{ item }">
                          <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.callStatuses, item.id)">{{item.name}}</v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row v-if="currentTab !== TUTOR_TAB_INDEX.ALL && filterForm.typeCustomerCare === TYPE_CALL_STATUS.CHAM_SOC_DINH_KY">
                    <v-col cols="4" class="d-flex align-center pl-6">
                      Lịch sử trạng thái cuộc gọi
                    </v-col>
                    <v-col cols="8">
                      <v-autocomplete
                        v-model="filterForm.historyCallStatusId"
                        :items="mapCallTypeIdAndListCallStatus[filterForm.historyCallId]"
                        item-text="name"
                        item-value="id"
                        placeholder="Chọn lịch sử trạng thái"
                        no-data-text="Không có dữ liệu"
                        clearable
                        multiple
                        hide-details
                        persistent-placeholder
                        dense
                        outlined
                        chips
                        clear-icon="mdi-trash-can-outline"
                      >
                        <template #selection="{ item }">
                          <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.historyCallStatusId, item.id)">{{item.name}}</v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row v-if="isLeadView">
                    <v-col cols="4" class="d-flex align-center pl-6">
                      Quản lý lớp
                    </v-col>
                    <v-col cols="8">
                      <v-autocomplete
                        @change="toggleSelectTeacher()"
                        v-model="filterForm.headTeacher"
                        :items="listTotalGVCNV2"
                        item-text="name"
                        item-value="id"
                        no-data-text="Không có dữ liệu"
                        :placeholder="filterForm.hasNoTeacher ? 'Không có quản lý lớp' : 'Chọn quản lý lớp'"
                        clearable
                        multiple
                        hide-details
                        persistent-placeholder
                        dense
                        outlined
                        chips
                        clear-icon="mdi-trash-can-outline"
                      >
                        <template #selection="{ item }">
                          <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.headTeacher, item.id)">{{handleCutChipText(item.name)}}</v-chip>
                        </template>
                        <template v-slot:prepend-item>
                          <v-list-item
                            ripple
                            @mousedown.prevent
                            @click="toggleHasNoTeacher"
                          >
                            <v-list-item-action>
                              <v-icon :color="filterForm.headTeacher && filterForm.headTeacher.length > 0 ? 'indigo darken-4' : ''">
                                {{ filterForm.hasNoTeacher ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}}
                              </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>
                                Không có quản lý lớp
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row v-if="$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE && filterForm.typeCustomerCare !== TYPE_CALL_STATUS.CHUYEN_SALES && filterForm.typeCustomerCare !== TYPE_CALL_STATUS.GIA_HAN">
                    <v-col cols="4" class="d-flex align-center pl-6">
                      Số ngày chưa chăm sóc
                    </v-col>
                    <v-col cols="8">
                      <v-row>
                        <v-col cols="12">
                          <div class="d-flex">
                            <v-text-field
                              v-model="rangeNumberLastCare.from"
                              style="margin-top: 2px; padding-top: 0"
                              type="number"
                              min="0"
                              class="custom-input-number"
                              :class="required ? 'required' : ''"
                              @change="changeNumberLastCare('from')"
                              @keydown="$event.key === '-' || $event.key === 'e' || $event.key === '.' ? $event.preventDefault() : null"
                              outlined
                              dense
                              hide-details
                            >
                              <template v-slot:prepend-inner>
                                <div class="mt-1 content-number"  :style="{color: required ? '#FF6B69' : ''}">Từ</div>
                              </template>
                              <template v-slot:append>
                                <div class="mt-1 content-number">Ngày</div>
                              </template>
                            </v-text-field>
                            <v-text-field
                              v-model="rangeNumberLastCare.to"
                              style="margin-top: 2px; padding-top: 0"
                              type="number"
                              class="custom-input-number ml-2"
                              :min="rangeNumberLastCare.from"
                              :class="required ? 'required' : ''"
                              @change="changeNumberLastCare('to')"
                              @keydown="$event.key === '-' || $event.key === 'e' || $event.key === '.' ? $event.preventDefault() : null"
                              outlined
                              dense
                              hide-details
                            >
                              <template v-slot:prepend-inner>
                                <div class="mt-1 content-number"  :style="{color: required ? '#FF6B69' : ''}">Đến</div>
                              </template>
                              <template v-slot:append>
                                <div class="mt-1 content-number">Ngày</div>
                              </template>
                            </v-text-field>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row v-if="(filterForm.typeCustomerCare === TYPE_CALL_STATUS.GIA_HAN || filterForm.typeCustomerCare === TYPE_CALL_STATUS.CHUYEN_SALES || currentTab === TUTOR_TAB_INDEX.ALL) && !isStaffCareSaleExtend">
                    <v-col cols="4" class="d-flex align-center pl-6">
                      Sale
                    </v-col>
                    <v-col cols="8">
                      <v-autocomplete
                        @change="toggleSelectSale()"
                        v-model="filterForm.sales"
                        :items="listSale ? listSale : []"
                        item-text="fullName"
                        item-value="id"
                        :placeholder="filterForm.hasNoSale ? 'Không có sale' : 'Chọn sale'"
                        no-data-text="Không có dữ liệu"
                        clearable
                        multiple
                        hide-details
                        dense
                        outlined
                        chips
                        clear-icon="mdi-trash-can-outline"
                      >
                        <template #selection="{item}">
                          <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.sales, item.id)">
                            {{handleCutChipText(item.fullName)}}
                          </v-chip>
                        </template>
                        <template v-slot:prepend-item>
                          <v-list-item
                            ripple
                            @mousedown.prevent
                            @click="toggleHasNoSale"
                          >
                            <v-list-item-action>
                              <v-icon :color="filterForm.sales.length > 0 ? 'indigo darken-4' : ''">
                                {{ filterForm.hasNoSale ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}}
                              </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>
                                Không có sale
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Thông tin học sinh</div>
                  <v-row v-if="filterForm.typeCustomerCare !== TYPE_CALL_STATUS.TAT_CA && currentTab !== TUTOR_TAB_INDEX.ALL">
                    <v-col cols="12">
                      <v-checkbox
                        v-model="filterForm.noEndDate"
                        @click="changeToNoEndDate()"
                        class="pl-2"
                        label="Học sinh không có hạn học"
                        hide-details
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" class="d-flex align-center pl-6">
                      Chương trình
                    </v-col>
                    <v-col cols="8">
                      <v-menu
                        v-if="$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE"
                        bottom
                        offset-y
                        content-class="menu-wrapper-tree-user"
                        :close-on-content-click="false">
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-if="(filterForm.programFilter && filterForm.programFilter.length === 0 && programFilterType === 1) || (filterForm.program_ids && filterForm.program_ids.length === 0 && programFilterType === 2)"
                            v-bind="attrs"
                            v-on="on">
                            <v-select
                              label="Chương trình"
                              readonly
                              hide-details
                              placeholder="Tìm kiếm theo chương trình"
                              outlined
                              dense
                            >
                            </v-select>
                          </div>
                          <div
                            v-bind="attrs"
                            v-on="on"
                            v-else
                            style="position: relative"
                          >
                            <div class="mt-1 tree-user-selected" v-show="programFilterType === 1">
                              <span
                                v-for="(node, index) in computedLevelName"
                                :key="node + index"
                              >
                                <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItemProgram(node, programFilterType, index)">
                                  {{ handleCutChipText(node, 30) }}
                                </v-chip>
                              </span>
                            </div>
                            <div class="mt-1 tree-user-selected" v-show="programFilterType === 2">
                              <span
                                v-for="(node, index) in computedProgramName"
                                :key="node + index"
                              >
                                <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItemProgram(node, programFilterType, index)">
                                  {{ handleCutChipText(node, 30) }}
                                </v-chip>
                              </span>
                            </div>
                            <v-icon
                              class="icon-clear-all"
                              color="grey"
                              @click="removeProgramLevelSelected()">mdi-trash-can-outline
                            </v-icon>
                          </div>
                        </template>
                        <template>
                          <div style="background: white; max-height: 400px; overflow: auto; padding: 0 12px">
                            <div style="min-width: 340px;">
                              <v-radio-group
                                style="justify-content: center"
                                class="custom-radio-group"
                                v-model="programFilterType"
                                row
                                hide-details
                              >
                                <v-radio
                                  label="Chọn theo level"
                                  :value="1"
                                ></v-radio>
                                <v-radio
                                  label="Chọn theo chương trình"
                                  :value="2"
                                ></v-radio>
                              </v-radio-group>
                            </div>
                            <v-text-field
                              class="px-6 pt-4"
                              label="Tìm kiếm..."
                              v-model="search"
                              hide-details
                            >
                            </v-text-field>
                            <v-treeview
                              v-show="programFilterType === 1"
                              v-model="filterForm.programFilter"
                              :search="search"
                              selectable
                              item-key="fakeId"
                              item-disabled="locked"
                              return-object
                              :items="treeListProgram"
                            ></v-treeview>
                            <v-treeview
                              v-show="programFilterType === 2"
                              v-model="filterForm.program_ids"
                              selectable
                              :items="listProgram"
                              :search="search"
                              item-text="title"
                              item-key="id"
                            ></v-treeview>
                          </div>
                        </template>
                      </v-menu>
                      <v-select
                        v-else
                        v-model="filterForm.program_ids"
                        :items="listProgram"
                        item-text="title"
                        item-value="id"
                        no-data-text="Không có dữ liệu"
                        placeholder="Chọn chương trình"
                        clearable
                        multiple
                        hide-details
                        persistent-placeholder
                        dense
                        outlined
                        clear-icon="mdi-trash-can-outline"
                      >
                        <template v-slot:selection="{item}">
                          <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.program_ids, item.id)">
                            {{ handleCutChipText(item.title) }}
                          </v-chip>
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" class="d-flex align-center pl-6">
                      Mã lớp
                    </v-col>
                    <v-col cols="8">
                      <v-text-field
                        v-model="filterForm.class_code"
                        placeholder="Nhập mã lớp"
                        clearable
                        hide-details
                        persistent-placeholder
                        dense
                        outlined
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" class="d-flex align-center pl-6">
                      Trạng thái học
                    </v-col>
                    <v-col cols="8">
                      <v-autocomplete
                        v-model="filterForm.status"
                        :items="HS_STATUSESBYQUERY ? HS_STATUSESBYQUERY : []"
                        item-text="name"
                        item-value="id"
                        multiple
                        clearable
                        placeholder="Chọn trạng thái học"
                        hide-details
                        persistent-placeholder
                        dense
                        outlined
                        chips
                        clear-icon="mdi-trash-can-outline"
                      >
                        <template #selection="{ item }">
                          <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.status, item.id)">{{item.name}}</v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row v-if="isShowStudyDateFilter">
                    <v-col cols="4" class="d-flex align-center pl-6">
                      <div class="d-flex align-start" :style="`color: ${filterForm.study_time && filterForm.study_time.length > 0 ? '' : 'rgba(0, 0, 0, .6)'}`">
                        <div style="width: 80%">Số bài tập chưa làm</div>
                        <v-tooltip top>
                          <template v-slot:activator="{on, attrs}">
                            <v-icon small v-on="on" v-bind="attrs">mdi-information-outline</v-icon>
                          </template>
                          <span>Chọn bộ lọc Thời gian học để nhập số bài tập chưa làm</span>
                        </v-tooltip>
                      </div>
                    </v-col>
                    <v-col cols="8">
                      <div class="d-flex">
                        <v-select
                          style="width: 70%"
                          placeholder="So sánh"
                          v-model="filterForm.compareHomeWorkType"
                          :items="compareHomeworkOptions"
                          :disabled="!filterForm.study_time || filterForm.study_time.length === 0"
                          clearable
                          item-text="label"
                          item-value="value"
                          @click:clear="filterForm.undoneHomework = null"
                          outlined
                          dense
                          hide-details
                        >
                        </v-select>
                        <v-text-field
                          placeholder="Nhập số bài tập"
                          @keydown="$event.key === '-' || $event.key === 'e' ? $event.preventDefault() : null"
                          min="0"
                          type="number"
                          :disabled="!filterForm.study_time || filterForm.study_time.length === 0"
                          v-model="filterForm.undoneHomework"
                          class="ml-2"
                          outlined
                          dense
                          hide-details
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-if="filterForm.typeCustomerCare === TYPE_CALL_STATUS.GIA_HAN || filterForm.typeCustomerCare === TYPE_CALL_STATUS.CHUYEN_SALES || currentTab === TUTOR_TAB_INDEX.ALL">
                    <v-col cols="4" class="d-flex align-center pl-6">
                      Số buổi đã học
                    </v-col>
                    <v-col cols="8">
                      <v-row >
                        <v-col cols="6" class="pr-0">
                          <v-select
                            v-model="filterForm.compareTypeNumberOfLessons"
                            :items="typeSearch"
                            item-text="label"
                            item-value="value"
                            label="So sánh"
                            hide-details
                            persistent-placeholder
                            outlined
                            dense
                          />
                        </v-col>
                        <v-col cols="6" class="pl-0">
                          <v-text-field
                            type="number"
                            min="0"
                            step="1"
                            class="ml-2"
                            label="Buổi đã học"
                            placeholder="Nhập số"
                            v-model="filterForm.numberOfLessons"
                            hide-details
                            persistent-placeholder
                            outlined
                            dense
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row v-if="$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY">
                    <v-col cols="4" class="d-flex align-center pl-6">
                      Trường học
                    </v-col>
                    <v-col cols="8">
                      <v-autocomplete
                        @change="toggleSelectStation()"
                        v-model="filterForm.school_id"
                        :items="listTotalStation ? listTotalStation : []"
                        item-text="school_name"
                        item-value="id"
                        no-data-text="Không có dữ liệu"
                        :placeholder="filterForm.hasNoSchool ? 'Không có trường học' : 'Chọn trường học'"
                        clearable
                        multiple
                        hide-details
                        persistent-placeholder
                        outlined
                        dense
                        chips
                        clear-icon="mdi-trash-can-outline"
                      >
                        <template #selection="{ item }">
                          <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.school_id, item.id)">{{handleCutChipText(item.school_name)}}</v-chip>
                        </template>
                        <template v-slot:prepend-item>
                          <v-list-item
                            ripple
                            @mousedown.prevent
                            @click="toggleHasNoSchool"
                          >
                            <v-list-item-action>
                              <v-icon :color="filterForm.school_id.length > 0 ? 'indigo darken-4' : ''">
                                {{ filterForm.hasNoSchool ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}}
                              </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>
                                Không có trường học
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Thời gian</div>
                  <v-row v-if="filterForm.typeCustomerCare === TYPE_CALL_STATUS.C0 || filterForm.typeCustomerCare === TYPE_CALL_STATUS.CHAM_SOC_DINH_KY">
                    <v-col cols="4" class="d-flex align-center pl-6">
                      Ngày khai giảng
                    </v-col>
                    <v-col cols="8">
                      <common-range-picker
                        :clearable="true"
                        :aLight="'left'"
                        v-model="filterForm.class_start_time"
                        class="'show-date"
                        :class="this.currentPicker === 1 ? 'show-date' : 'hide-date'"
                        @show-date-picker="showDate(1)"
                        @check-close-on-click="checkCloseOnClick"
                        isFilter
                        noneMargin
                      ></common-range-picker>
                    </v-col>
                  </v-row>
                  <v-row v-if="isShowStudyDateFilter">
                    <v-col cols="4" class="d-flex align-center pl-6">
                      Thời gian học
                    </v-col>
                    <v-col cols="8">
                      <common-range-picker
                        :clearable="true"
                        :aLight="'left'"
                        v-model="filterForm.study_time"
                        class="'show-date"
                        :class="this.currentPicker === 1 ? 'show-date' : 'hide-date'"
                        @show-date-picker="showDate(1)"
                        @check-close-on-click="checkCloseOnClick"
                        isFilter
                        noneMargin
                      ></common-range-picker>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" class="d-flex align-center pl-6">
                      Ngày hết hạn
                    </v-col>
                    <v-col cols="8">
                      <common-range-picker
                        :clearable="true"
                        :aLight="'left'"
                        v-model="filterForm.courseEndDate"
                        class="'show-date"
                        :class="this.currentPicker === 1 ? 'show-date' : 'hide-date'"
                        @show-date-picker="showDate(1)"
                        @check-close-on-click="checkCloseOnClick"
                        @input="updateCourseEndDate()"
                        isFilter
                        noneMargin
                      ></common-range-picker>
                    </v-col>
                  </v-row>
                  <v-row v-if="filterForm.typeCustomerCare !== TYPE_CALL_STATUS.TAT_CA && currentTab !== TUTOR_TAB_INDEX.ALL">
                    <v-col cols="4" class="d-flex align-center pl-6">
                      Ngày hết hạn liền trước
                    </v-col>
                    <v-col cols="8">
                      <common-range-picker
                        :clearable="true"
                        :aLight="'left'"
                        v-model="filterForm.previous_end_date"
                        class="'show-date"
                        :class="this.currentPicker === 1 ? 'show-date' : 'hide-date'"
                        @show-date-picker="showDate(1)"
                        @check-close-on-click="checkCloseOnClick"
                        isFilter
                        noneMargin
                      ></common-range-picker>
                    </v-col>
                  </v-row>
                  <v-row v-if="filterForm.typeCustomerCare === TYPE_CALL_STATUS.GIA_HAN || filterForm.typeCustomerCare === TYPE_CALL_STATUS.CHUYEN_SALES">
                    <v-col cols="4" class="d-flex align-center pl-6">
                      {{filterForm.typeCustomerCare === TYPE_CALL_STATUS.CHUYEN_SALES && $route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE ? 'Ngày chuyển sale' : 'Ngày chuyển gia hạn'}}
                    </v-col>
                    <v-col cols="8">
                      <common-range-picker
                        :clearable="true"
                        :aLight="'left'"
                        v-model="filterForm.extend_at"
                        class="'show-date"
                        :class="this.currentPicker === 1 ? 'show-date' : 'hide-date'"
                        @show-date-picker="showDate(1)"
                        @check-close-on-click="checkCloseOnClick"
                        isFilter
                        noneMargin
                      ></common-range-picker>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" v-if="currentTab === TUTOR_TAB_INDEX.PeriodicallyCare">
                  <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Khác</div>
                  <v-row>
                    <v-col cols="4" class="d-flex align-center pl-6">
                      Tag
                    </v-col>
                    <v-col cols="8">
                      <v-select
                        multiple
                        v-model="filterForm.tags"
                        outlined
                        dense
                        hide-details
                        chips
                        :items="computedTagOption"
                        clearable
                        clear-icon="mdi-trash-can-outline"
                      >
                        <template v-slot:selection="{item}">
                          <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(filterForm.tags, item.value)">
                            {{item.text}}
                          </v-chip>
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                </v-col>
              </div>
            </v-row>
          </v-col>
        </v-row>
        <v-divider style="margin-bottom: 20px;margin-top: 20px;"></v-divider>
        <div class="text-center mb-4 ">
          <v-btn class="primary mx-2" @click="searchContact" style="background-color: #E91E63 !important">
            Áp dụng bộ lọc
          </v-btn>
          <v-menu offset-y v-if="isShowDownloadBtn">
            <template v-slot:activator="{on, attrs}">
              <v-btn
                v-on="currentTab !== TUTOR_TAB_INDEX.SpecialCare ? on : ''"
                v-bind="attrs"
                class="primary mx-2"
                @click="currentTab === TUTOR_TAB_INDEX.SpecialCare ? downloadExcel(filterForm) : ''"
              >
                <v-icon>mdi-download</v-icon>
                Download
              </v-btn>
            </template>
            <v-list>
              <v-list-item-group>
                <v-list-item>
                  <img src="../assets/download-excel-icon.svg" alt="" class="mr-3">
                  <v-list-item-title
                    @click="downloadExcel(filterForm)"
                  >Download File thường</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="isShowTransactionDownload">
                  <img src="../assets/download-transaction-icon.svg" alt="" class="mr-3">
                  <v-list-item-title @click="downloadReportTransaction(filterForm)">Download file theo đơn hàng</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>
<script>
import {
  SCHOOL_LEVEL, TYPE_CURRICULUM_OBJ,
  TYPE_CALL_STATUS, TYPE_CALL_STATUS_SELECT, HS_STATUSES, LEVEL_ENGLISH, LEVEL_DEFAULT,
} from '@/helpers/constant';
import { LIST_TYPE, TASK_STATUS_OPTION, LIST_TYPE_SELECT } from '@/modules/blended/const';
import { TUTOR_TAB_INDEX, TAG_OPTIONS } from '@/modules/student_care/constant/constant';
import { mapActions, mapGetters, mapState } from 'vuex';
import StudentCareServices from '@/services/StudentCareServices';
import * as moment from 'moment';

export default {
  name: 'ContactStatusFilterForm',
  props: ['filter', 'filterForm', 'testerOrOperatorList', 'checkRoute', 'dateInvite', 'listTesters', 'listCase', 'listSaleInviteTest', 'currentTab'],
  data() {
    return {
      TAG_OPTIONS,
      SCHOOL_LEVEL,
      TYPE_CURRICULUM_OBJ,
      LIST_TYPE_SELECT,
      TASK_STATUS_OPTION,
      LIST_TYPE,
      programFilterType: 1,
      search: null,
      treeSelect: null,
      isLoadData: false,
      specialCareFilter: {
        studentOff: false,
        studentLateEarly: false,
        studentHw: false,
        studentTestLow: false,
        studentCancelLesson: false,
        studentChangeTeacher: false,
        studentChangeTeacherCover: false,
      },
      typeSearch: [{ value: 'eq', label: 'BẰNG' }, { value: 'lt', label: 'NHỎ HƠN' }, { value: 'gt', label: 'LỚN HƠN' }],
      commonCompareOptions: [
        {
          value: 'lt',
          label: 'Nhỏ hơn',
        },
        {
          value: 'gt',
          label: 'Lớn hơn',
        },
        {
          value: 'eq',
          label: 'Bằng',
        },
      ],
      compareHomeworkOptions: [
        {
          value: 'lt',
          label: 'Nhỏ hơn',
        },
        {
          value: 'gt',
          label: 'Lớn hơn',
        },
      ],
      typeSearchLatestDate: [
        {
          value: 'between',
          label: 'BẰNG',
        },
        {
          value: 'lte',
          label: 'LỚN HƠN HOẶC BẰNG',
        },
        {
          value: 'lt',
          label: 'LƠN HƠN',
        },
      ],
      productList: [],
      subjects: [{ id: 1, name: 'Toán' }, { id: 15, name: 'Ngữ Văn' }, { id: 5, name: 'Tiếng anh' }],
      searchInput: null,
      searchDateTest: null,
      currentPicker: null,
      TYPE_CALL_STATUS,
      TYPE_CALL_STATUS_SELECT,
      HS_STATUSES,
      TUTOR_TAB_INDEX,
      items: [
        ...LEVEL_ENGLISH, ...LEVEL_DEFAULT,
      ],
      rangeNumberLastCare: { from: null, to: null },
      required: false,
      listCourse: [],
      HS_STATUSESBYQUERY: [],
      closeOnClickOutside: true,
    };
  },
  computed: {
    ...mapState('student_care', ['listCallType', 'listCallStatus', 'listTotalGVCNV2', 'listSale', 'countStatusModuleList', 'listProgram', 'listTotalStation', 'listGVCNV2', 'listGVCN']),
    ...mapGetters('user', ['isLeadView', 'isStaffCareSaleExtend']),
    ...mapGetters('contact_status', ['mapCallTypeIdAndListCallStatus']),
    computedTagOption() {
      if (this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.PRIMARY) {
        return TAG_OPTIONS.TUTOR_PRIMARY;
      }
      if (this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY) {
        return TAG_OPTIONS.TUTOR_SECONDARY;
      }
      return [];
    },
    isShowStudyDateFilter() {
      return this.$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE
        && this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.PRIMARY
        && [TUTOR_TAB_INDEX.CourseExtension, TUTOR_TAB_INDEX.PeriodicallyCare, TUTOR_TAB_INDEX.TransferSales].includes(this.currentTab);
    },
    isShowTransactionDownload() {
      return this.$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE && this.currentTab === TUTOR_TAB_INDEX.PeriodicallyCare;
    },
    isShowDownloadBtn() {
      if ((this.currentTab === TUTOR_TAB_INDEX.SpecialCare && this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY) || this.currentTab === TUTOR_TAB_INDEX.TutorTask) {
        // return this.checkAuthorization('special-care-tutor-download_read');
        return false;
      }
      return true;
    },
    computedTypeCallStatusSelect() {
      const result = _.cloneDeep(TYPE_CALL_STATUS_SELECT);
      if (this.$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE) {
        result[0].name = 'TA0';
      } else {
        result[0].name = 'C0';
      }
      return result;
    },
    computedProgramName() {
      return this.filterForm.program_ids ? this.listProgram.filter((e) => this.filterForm.program_ids.includes(e.id)).map((e) => e.title) : [];
    },
    computedLevelName() {
      return this.filterForm.programFilter ? this.filterForm.programFilter.map((e) => e.programLevelName) : [];
    },
    treeListProgram() {
      let result = [];
      result = _.cloneDeep(this.listProgram);
      result.forEach((e) => {
        e.name = e.title;
        e.fakeId = e.id.toString();
        if (e.subject_id === 3) {
          e.children = _.cloneDeep(LEVEL_ENGLISH);
          e.children.forEach((child) => {
            // eslint-disable-next-line no-param-reassign,radix
            child.fakeId = `${e.id.toString()}_${child.id.toString()}`;
            if (child.children) {
              child.children.forEach((grandChild) => {
                // eslint-disable-next-line no-param-reassign,radix
                grandChild.fakeId = `${e.id.toString()}_${child.id.toString()}_${grandChild.id.toString()}`;
                // eslint-disable-next-line no-param-reassign
                grandChild.programLevelName = `${e.name} - ${child.name} - ${grandChild.name}`;
              });
            } else {
              // eslint-disable-next-line no-param-reassign
              child.programLevelName = `${e.name} - ${child.name}`;
            }
          });
        } else if (e.subject_id !== 15) {
          e.children = _.cloneDeep(LEVEL_DEFAULT);
          e.children.forEach((child) => {
            // eslint-disable-next-line no-param-reassign,radix
            child.fakeId = `${e.id.toString()}_${child.id.toString()}`;
            // eslint-disable-next-line no-param-reassign
            child.programLevelName = `${e.name} - ${child.name}`;
          });
        } else {
          e.programLevelName = `${e.name}`;
          e.fakeId = e.id.toString();
        }
      });
      return result;
    },
  },
  async created() {
    if (this.$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY) {
      const data = _.cloneDeep(this.HS_STATUSES);
      this.HS_STATUSESBYQUERY = data.filter((e) => e.id !== 15);
    }
    await this.getListCourse();
  },
  watch: {
    '$route.name': function () {
      this.specialCareFilter = {
        studentOff: false,
        studentLateEarly: false,
        studentHw: false,
        studentTestLow: false,
        studentCancelLesson: false,
        studentChangeTeacher: false,
      };
    },
    closeOnClickOutside(val) {
      this.$emit('change-close-on-click', val);
    },
    'filterForm.study_time': function (val) {
      if (val.length === 0) {
        this.filterForm.compareHomeWorkType = null;
        this.filterForm.undoneHomework = null;
      } else {
        const diffDays = parseInt((new Date(val[1]) - new Date(val[0])) / (1000 * 60 * 60 * 24), 10);
        if (diffDays && Math.abs(diffDays) > 30) {
          this.$emit('change-close-on-click', false);
          this.$swal({
            icon: 'error',
            title: 'Lỗi !',
            text: 'Chỉ lựa chọn khoảng thời gian tối đa 1 tháng !!',
          }).then(() => {
            this.$emit('change-close-on-click', true);
          });
          this.filterForm.study_time = [];
        }
      }
    },
    programFilterType(val) {
      if (val === 1) {
        this.filterForm.program_ids = [];
      } else {
        this.filterForm.programFilter = [];
      }
    },
    'filterForm.programFilter': function (val, oldVal) {
      if (val && val.length > 10) {
        this.$swal.fire({
          title: 'Thông báo',
          text: 'Chỉ được tối đa 10 tick chọn tại lọc Level',
          icon: 'warning',
        }).then(() => {
          this.filterForm.programFilter = _.cloneDeep(oldVal);
          setTimeout(() => {
            this.filter.closeMenu = true;
          }, 200);
        });
      }
    },
    '$route.query.typeCurriculum': {
      handler(val) {
        if (val === TYPE_CURRICULUM_OBJ.IELTSY) {
          const data = _.cloneDeep(this.HS_STATUSES);
          this.HS_STATUSESBYQUERY = data.filter((e) => e.id !== 15);
        } else {
          this.HS_STATUSESBYQUERY = this.HS_STATUSES;
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('blended', ['getListTask']),
    ...mapActions('student_care', ['getListCallStatus', 'getDataPeriodicallyCareTable', 'getListCallStatusCount']),
    validateSpecialFilter() {
      if ((this.specialCareFilter.studentHw && (!this.filterForm.studentHw || !this.filterForm.typeStudentHw))
        || (this.specialCareFilter.studentOff && (!this.filterForm.student_off || !this.filterForm.typeStudentOff))
        || (this.specialCareFilter.studentChangeTeacher && (!this.filterForm.studentChangeTeacher || !this.filterForm.typeStudentChangeTeacher))
        || (this.specialCareFilter.studentLateEarly && (!this.filterForm.studentLateEarly || !this.filterForm.typeStudentLateEarly))
        || (this.specialCareFilter.studentCancelLesson && (!this.filterForm.studentCancelLesson || !this.filterForm.typeStudentCancelLesson))
      ) {
        this.closeOnClickOutside = false;
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Vui lòng chọn điều kiện so sánh!',
        }).then(() => {
          this.closeOnClickOutside = true;
        });
        return false;
      } return true;
    },
    checkCloseOnClick(val) {
      this.closeOnClickOutside = !val;
    },
    handleCutChipText(text, number = 20) {
      return text.length > number ? `${text.slice(0, number - 2)}...` : text;
    },
    removeItem(items, item) {
      const index = items.indexOf(item);
      if (index >= 0) items.splice(index, 1);
    },
    removeItemProgram(node, programFilterType, index) {
      // eslint-disable-next-line no-unused-expressions
      programFilterType === 1 ? this.filterForm.programFilter.splice(index, 1) : this.filterForm.program_ids.splice(index, 1);
    },
    removeProgramLevelSelected() {
      if (this.programFilterType === 1) {
        this.filterForm.programFilter = [];
      } else {
        this.filterForm.program_ids = [];
      }
    },
    closeMenuPopup() {
      this.filter.closeMenu = false;
    },
    updateCourseEndDate() {
      this.filterForm.noEndDate = false;
    },
    async searchContact() {
      if (this.required) return;
      if ((!this.rangeNumberLastCare.from && this.rangeNumberLastCare.to) || (!this.rangeNumberLastCare.to && this.rangeNumberLastCare.from)) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Vui lòng nhập đủ khoảng ngày chưa chăm sóc!',
        });
        return;
      }
      if (this.currentTab === TUTOR_TAB_INDEX.SpecialCare && !this.validateSpecialFilter()) {
        return;
      }
      const loading = this.$loading.show();
      this.filterForm.page = 1;
      this.filterForm.pendingPage = 1;
      if (this.currentTab === TUTOR_TAB_INDEX.TutorTask) {
        await this.getListTask(this.filterForm);
        Bus.$emit('recountTotalSuccess');
      } else {
        if (this.rangeNumberLastCare.to && this.rangeNumberLastCare.from) {
          this.filterForm.lastestCareDate = this.convertRangeDate();
        } else {
          this.filterForm.lastestCareDate = '';
        }
        // this.filterForm.lastestCareDate = this.convertRangeDate();
        await this.getDataPeriodicallyCareTable(this.filterForm);
        await this.getListCallStatusCount(this.filterForm);
      }
      loading.hide();
      this.closeMenuPopup();
    },
    changeToNoEndDate() {
      if (this.filterForm.noEndDate) {
        this.filterForm.courseEndDate = [];
      }
    },
    toggleHasNoTeacher() {
      this.$nextTick(() => {
        this.filterForm.hasNoTeacher = !this.filterForm.hasNoTeacher;
        this.filterForm.headTeacher = [];
      });
    },
    toggleHasNoSchool() {
      this.$nextTick(() => {
        this.filterForm.hasNoSchool = !this.filterForm.hasNoSchool;
        this.filterForm.school_id = [];
      });
    },
    toggleSelectTeacher() {
      this.$nextTick(() => {
        if (this.filterForm.headTeacher && this.filterForm.headTeacher.length > 0) {
          this.filterForm.hasNoTeacher = false;
        }
      });
    },
    toggleSelectStation() {
      this.$nextTick(() => {
        if (this.filterForm.school_id.length > 0) {
          this.filterForm.hasNoSchool = false;
        }
      });
    },
    toggleHasNoSale() {
      this.$nextTick(() => {
        this.filterForm.hasNoSale = !this.filterForm.hasNoSale;
        this.filterForm.sales = [];
      });
    },
    toggleSelectSale() {
      this.$nextTick(() => {
        if (this.filterForm.sales.length > 0) {
          this.filterForm.hasNoSale = false;
        }
      });
    },
    showDate(index) {
      this.currentPicker = index;
    },
    // check bo loc ko duoc de trong
    checkIsEmpty(filterForm) {
      // khoi tao bien check rong
      let isDateTime = true;
      let isType = true;
      let isCaseTypeIds = true;
      let isCreatedAt = true;
      let isCreatedBy = true;
      let isInterviewUser = true;
      let isListInterviews = true;
      let isOperatorOrTesterId = true;
      let isSearchInfo = true;
      let isSelectedShift = true;
      let isStatus = true;
      let isSubjectId = true;

      // chay dieu kien check rong
      if (filterForm.dateTime && filterForm.dateTime.length === 0) isDateTime = false;
      if (filterForm.type == null) isType = false;
      if (filterForm.caseTypeIds && filterForm.caseTypeIds.length === 0) isCaseTypeIds = false;
      if (filterForm.createdAt && filterForm.createdAt.length === 0) isCreatedAt = false;
      if (filterForm.createdBy && filterForm.createdBy.length === 0) isCreatedBy = false;
      if (filterForm.interviewUser && filterForm.interviewUser.length === 0) isInterviewUser = false;
      if (filterForm.listInterviews && filterForm.listInterviews.length === 0) isListInterviews = false;
      if (filterForm.operatorOrTesterId && filterForm.operatorOrTesterId.length === 0) isOperatorOrTesterId = false;
      if (filterForm.searchInfo === '') isSearchInfo = false;
      if (filterForm.selectedShift && filterForm.selectedShift.length === 0) isSelectedShift = false;
      if (filterForm.status === '') isStatus = false;
      if (filterForm.subjectId == null) isSubjectId = false;

      if (isDateTime || isType || isCaseTypeIds || isCreatedAt || isCreatedBy || isInterviewUser
        || isListInterviews || isOperatorOrTesterId || isSearchInfo || isSelectedShift || isStatus || isSubjectId) {
        return true;
      } return false;
    },
    async downloadReportTransaction(filterForm) {
      const check = this.checkIsEmpty(filterForm);
      if (!check) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Vui lòng chọn ít nhất 1 điều kiện tìm kiếm',
        });
        return;
      }
      Bus.$emit('download-excel-filter-data-transaction', filterForm);
    },
    async downloadExcel(filterForm) {
      const check = this.checkIsEmpty(filterForm);
      if (!check) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Vui lòng chọn ít nhất 1 điều kiện tìm kiếm',
        });
        return;
      }
      Bus.$emit('download-excel-filter', filterForm);
    },
    changeNumberLastCare(type) {
      if (!(Number(this.rangeNumberLastCare.from >= 0) && Number.isInteger(Number(this.rangeNumberLastCare.from)))) this.rangeNumberLastCare.from = null;
      if (!(Number(this.rangeNumberLastCare.to >= 0) && Number.isInteger(Number(this.rangeNumberLastCare.to)))) this.rangeNumberLastCare.to = null;
      if ((type === 'from' && Number(this.rangeNumberLastCare.from) > Number(this.rangeNumberLastCare.to) && this.rangeNumberLastCare.to !== null) || (type === 'to' && Number(this.rangeNumberLastCare.to) < Number(this.rangeNumberLastCare.from) && this.rangeNumberLastCare.from !== null)) {
        this.required = true;
      } else {
        this.required = false;
      }
    },
    convertRangeDate() {
      return `['${moment(new Date()).subtract(this.rangeNumberLastCare.to, 'd').format('YYYY-MM-DD')} 00:00:00', '${moment(new Date()).subtract(this.rangeNumberLastCare.from, 'd').format('YYYY-MM-DD')} 23:59:59']`;
    },
    async getListCourse() {
      const res = await StudentCareServices.getListCourse();
      if (res && res.error) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Có lỗi xảy ra, vui lòng thử lại !',
        });
      } else {
        this.listCourse = res.data;
      }
    },
  },
};
</script>
<style lang="css">
.custom-compare-input .v-input__prepend-inner {
  margin-top: 0px !important;
}
.custom-compare-input .v-input__append-inner {
  margin-top: 14px !important;
}
.custom-solo-select.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
  padding: 0;
}
.custom-solo-select .v-input__append-inner {
  margin-top: 0 !important;
}
.icon-clear-all {
  position: absolute !important;
  right: 15px;
  top: 20px;
  /*background: white;*/
}
.tree-user-selected {
  min-height: 34px;
  overflow-y: auto;
  border: 1px solid #d2d2d2;
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  row-gap: 4px;
  column-gap: 4px;
  padding: 8px 40px 8px 8px;
}
/deep/.hide-date .daterangepicker.dropdown-menu{
  display: none
}
/deep/.show-date .daterangepicker.dropdown-menu{
  display: block;
}
/deep/.v-subheader.theme--light {
    background: #ddd;
}
.custom-radio-group .v-input--radio-group__input{
  justify-content: center;
}
</style>
<style lang="scss">
.content-number {
  color: #9B9B9B;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  }
 .custom-input-number {
  .v-text-field__slot {
    input {
      padding: 0px 0px 0px 4px;
      text-align: center;
    }
  }
   &.required {
      .v-text-field__slot {
        input {
          color: #FF6B69 !important;
        }
      }
    }
 }
</style>
